/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_Density_ComfortableInputs */

const en_disp_density_comfortable = /** @type {(inputs: Disp_Density_ComfortableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comfortable`)
};

const de_disp_density_comfortable = /** @type {(inputs: Disp_Density_ComfortableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Großzügig`)
};

/**
* | output |
* | --- |
* | "Comfortable" |
*
* @param {Disp_Density_ComfortableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_density_comfortable = /** @type {((inputs?: Disp_Density_ComfortableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_Density_ComfortableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_density_comfortable(inputs)
	return en_disp_density_comfortable(inputs)
});